import { makeAutoObservable } from 'mobx'
import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui'
import { IntegrationKey } from 'entities/Integrations'

export class RingFirstDropdownStore {
  constructor(initValue?: string) {
    if (initValue) {
      this.setValue(initValue)
    }
    makeAutoObservable(this)
  }
  private _value = 'simultaneous'
  get value() {
    return this._value
  }
  setValue = (value: string) => {
    this._value = value
  }

  get items() {
    const [id, childrenId] = this.value.split('.')
    return items.map((item) => {
      const activeChild = item.children?.find((child) => child.id === childrenId)
      return item.id === id
        ? {
            ...item,
            activeValue: activeChild?.label || true,
            children: item.children?.map((child) =>
              child.id === activeChild?.id ? { ...activeChild, activeValue: true } : child
            ),
          }
        : item
    })
  }
  get activeItem() {
    const [id, childrenId] = this.value.split('.')
    const findActiveItem = items.find((item) => item.id === id)
    return childrenId
      ? findActiveItem?.children?.find((child) => child.id === childrenId)
      : findActiveItem
  }
}

const items: IDropdownItem[] = [
  {
    id: 'simultaneous',
    label: 'Simultaneously',
    variant: EnumDropdownItemVariant.CheckedRight,
  },
  {
    id: 'round_robin',
    label: 'Round robin',
    variant: EnumDropdownItemVariant.CheckedRight,
  },
  {
    id: 'sequential',
    label: 'Linear round robin',
    variant: EnumDropdownItemVariant.CheckedRight,
    divider: true,
  },
  {
    id: IntegrationKey.salesmsg,
    label: 'Salesmsg',
    iconL: 'salesmsg',
    iconR: 'chevronRight',
    children: [
      {
        id: 'contact_owner',
        label: 'Contact owner',
        iconL: 'salesmsg',
        variant: EnumDropdownItemVariant.CheckedRight,
      },
      {
        id: 'conversation_assignee',
        label: 'Conversation assignee',
        iconL: 'salesmsg',
        variant: EnumDropdownItemVariant.CheckedRight,
      },
    ],
  },
  {
    id: IntegrationKey.hubspot,
    label: 'HubSpot',
    iconL: 'hubspot',
    iconR: 'chevronRight',
    children: [
      {
        id: 'contact_owner',
        label: 'Contact owner',
        iconL: 'hubspot',
        variant: EnumDropdownItemVariant.CheckedRight,
      },
      {
        id: 'deal_owner',
        label: 'Deal owner',
        iconL: 'hubspot',
        variant: EnumDropdownItemVariant.CheckedRight,
      },
    ],
  },
]
